import { render, staticRenderFns } from "./OrderComplaintUnderway.vue?vue&type=template&id=5abdfd3c&"
import script from "./OrderComplaintUnderway.vue?vue&type=script&lang=ts&"
export * from "./OrderComplaintUnderway.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports